import { render, staticRenderFns } from "./FeedbackEnd.vue?vue&type=template&id=9f77988a&scoped=true&"
import script from "./FeedbackEnd.vue?vue&type=script&lang=js&"
export * from "./FeedbackEnd.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackEnd.vue?vue&type=style&index=0&id=9f77988a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f77988a",
  null
  
)

export default component.exports